module.exports = __webpack_public_path__ + "img/149.1165c058.jpg";